// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__221DB","col":"styles_col__2iga1"};